<template>
  <div>
    <div class="mx-auto mt-16 pt-1" :class="isMobile ? 'w-full px-2' : 'section'">
      <template v-if="isAddTeiki">
        <div class="float-left">
          <button class="w-20 px-3 mb-2 font-bold border-2 rounded-md bg-white cursor-pointer" @click="back()">
            ＜戻る
          </button>
        </div>
        <div class="text-center font-bold">2区間目を検索</div>
      </template>
      <div v-if="isAddTeiki">
        <div class="mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
          現在お持ちの「2区間定期券」「分割定期券」の2区間目の区間・種別・月数を入力し、「経路を検索」ボタンを押してください
        </div>
      </div>
      <div v-else class="clear-both">
        <div class="mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
          現在お持ちの定期券区間・種別・月数を入力し、「経路を検索」ボタンを押してください
        </div>
      </div>
      <div class="text-center mx-auto mt-2 mb-4">
        <div class="float-left text-white base-color rounded-md py-1"
          :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
          乗車駅
        </div>
        <div class="pl-2 pt-1" id="from" ref="from" :class="isMobile ? 'ml-20' : 'ml-24'">
        </div>
      </div>
      <div>
        <div class="text-center mx-auto mt-2 mb-4" v-show="viaCount >= 1">
          <div class="float-left text-white base-color rounded-md py-1"
            :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(1)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via1" ref="via1" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
        <div class="text-center mx-auto mt-2 mb-4" v-show="viaCount >= 2">
          <div class="float-left text-white base-color rounded-md py-1"
            :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(2)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via2" ref="via2" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
        <div class="text-center mx-auto mt-2 mb-6" v-show="viaCount >= 3">
          <div class="float-left text-white base-color rounded-md py-1"
            :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
            経由駅
          </div>
          <div class="float-right relative mr-6 cursor-pointer" @click="deleteVia(3)">
            <div class="absolute mt-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                fill="#000000">
                <path
                  d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>
          </div>
          <div class="pl-2 pt-1" id="via3" ref="via3" :class="isMobile ? 'ml-20' : 'ml-24'">
          </div>
        </div>
      </div>
      <div v-show="viaCount < 3" class="text-center">
        <span class="text-blue-600 font-bold mb-4 cursor-pointer" @click="addVia()">＋経由駅を追加</span>
      </div>
      <div class="text-center mx-auto mt-2">
        <div class="float-left text-white base-color rounded-md py-1"
          :class="isMobile ? 'text-base w-20 mt-1' : 'text-xl w-24'">
          降車駅
        </div>
        <div class="pl-2 pt-1" id="to" ref="to" :class="isMobile ? 'ml-20' : 'ml-24'">
        </div>
      </div>
      <div class="my-2" v-if="mode === 'teiki'">
        <template v-if="isMobile">
          <div class="font-bold float-left ml-2 mt-2">定期種別：</div>
          <select v-model="teikiKind" class="border-2 rounded mt-2">
            <option value="bussiness">通勤/オフピーク</option>
            <option value="university">通学 (大学)</option>
            <option value="highSchool">通学 (高校)</option>
            <option value="juniorHighSchool">通学 (中学)</option>
          </select>
        </template>
        <template v-else>
          <div class="font-bold ml-2 pt-2">定期種別</div>
          <div class="float-left ml-4 pt-1">
            <input id="bussiness" type="radio" v-model="teikiKind" value="bussiness" /><label for="bussiness"
              class="ml-2">通勤/オフピーク</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="university" type="radio" v-model="teikiKind" value="university" /><label for="university"
              class="ml-2">通学 (大学)</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="highSchool" type="radio" v-model="teikiKind" value="highSchool" /><label for="highSchool"
              class="ml-2">通学 (高校)</label>
          </div>
          <div class="float-left ml-6 pt-1">
            <input id="juniorHighSchool" type="radio" v-model="teikiKind" value="juniorHighSchool" /><label
              for="juniorHighSchool" class="ml-2">通学 (中学)</label>
          </div>
        </template>
      </div>
      <template v-if="!isAddTeiki">
        <div class="my-2 clear-both" v-if="mode === 'teiki'">
          <template v-if="isMobile">
            <div class="font-bold float-left ml-2 mt-2">購入月数：</div>
            <select v-model="teikiValidity" class="border-2 rounded mt-2">
              <option value="1">1ヶ月</option>
              <option value="3">3ヶ月</option>
              <option value="6">6ヶ月</option>
            </select>
          </template>
          <template v-else>
            <div class="font-bold ml-2 pt-2">購入月数</div>
            <div class="float-left ml-4 pt-1">
              <input id="teiki1" type="radio" v-model="teikiValidity" value="1" /><label for="teiki1"
                class="ml-2">1ヶ月</label>
            </div>
            <div class="float-left ml-6 pt-1">
              <input id="teiki3" type="radio" v-model="teikiValidity" value="3" /><label for="teiki3"
                class="ml-2">3ヶ月</label>
            </div>
            <div class="float-left ml-6 pt-1">
              <input id="teiki6" type="radio" v-model="teikiValidity" value="6" /><label for="teiki6"
                class="ml-2">6ヶ月</label>
            </div>
          </template>
        </div>
      </template>
      <div class="clear-both"></div>
      <div v-for="(error, index) in errors" :key="index" class="w-full text-center text-red-500 font-bold">
        {{ error }}
      </div>
      <div class="text-center mx-auto mt-4">
        <button class="font-bold text-xl w-64 rounded-md py-1 text-white bg-blue-600" :class="isMobile ? '' : ''"
          @click="search('before')">
          経路を検索
        </button>
      </div>
      <template v-if="isAddTeiki">
        <ul class="ml-4 mt-4">
          <li>○乗車駅・降車駅は、現在お持ちの「2区間定期券」「分割定期券」の定期券区間を入力してください。</li>
        </ul>
      </template>
      <template v-else>
        <div v-if="isUsePage" class="mt-8 ml-4">
          【ご利用方法】
          <ul class="ml-4">
            <li>○乗車駅・降車駅は、現在お持ちの定期券区間を入力してください。<br />
              ※システム上、実際に発売できない区間の定期券も入力が可能な場合があります。</li>
            <li>○他の鉄道会社の区間を含む定期券は、乗車駅にJR東日本の駅を入力してください。</li>
            <li>○経路がＴ字となる場合や、定期券の区間を途中で打ち切る場合に発売する「二区間定期券」の入力は、この画面で
              １区間目を入力し、確定後に２区間目を入力してください。</li>
            <li>○新たにお求めいただく定期券の有効月数は、現在お持ちの定期券の有効月数と同一として計算します。</li>
            <li>○定期券の利用区間や種別が変更になる場合は、本サイトのご案内の対象外となります。</li>
          </ul>
        </div>
        <div v-else class="mt-8 ml-4">
          ～ご利用にあたって～
          <ul class="ml-4">
            <li>○本サイトは、必ず安くお求めいただけることをお約束するものではございません。改定前運賃での購入をご検討いただく際の参考としてご利用ください。</li>
            <li>○乗車駅・降車駅は、現在お持ちの定期券区間を入力してください。<br />
              ※システム上、実際に発売できない区間の定期券も入力が可能な場合がございます。</li>
            <li>○他の鉄道会社の区間を含む定期券は、乗車駅にJR東日本の駅を入力してください。</li>
            <li>○経路がＴ字となる場合や、定期券の区間を途中で打ち切る場合に発売する「二区間定期券」の入力は、この画面で
              １区間目を入力し、確定後に２区間目を入力してください。</li>
            <li>○新たにお求めいただく定期券の有効月数は、現在お持ちの定期券の有効月数と同一として計算します。</li>
            <li>○<span class="text-red-500">現在お持ちの定期券と新たに購入いただく定期券の重複する期間の払いもどしはできません。</span></li>
            <li>○定期券の利用区間や種別が変更になる場合は、本サイトのご案内の対象外となります。</li>
            <li>○定期券の残りの有効期間が1ヶ月以上残っている場合、払いもどしができる場合があります。<br />
              <a href="https://www.jreast.co.jp/kippu/22.html" target="_blank"
                class="text-blue-600 underline">きっぷの払いもどし：JR東日本</a>
            </li>
          </ul>
        </div>
        <div class="text-red-500 mt-8 ml-4 hidden">
          <ul v-if="mode === 'fare'">
            <li>※乗車駅にはJR各社の駅を入力してください。</li>
            <li>※降車駅にはJR以外の鉄道会社の駅も入力可能です。（発売範囲には制限があります。）</li>
            <li>※検索結果の運賃・料金及び区間等の制約事項は<button class="text-blue-600 underline break-all cursor-pointer"
                @click="openUpdate">注釈ページ</button>をご覧ください。</li>
          </ul>
          <ul v-else-if="mode === 'teiki'">
            <li>※乗車駅にはJR東日本の駅を入力してください。</li>
            <li>※降車駅にはJR以外の鉄道会社の駅も入力可能です。（発売範囲には制限があります。）</li>
            <li>※検索結果の運賃・料金及び区間等の制約事項は<button class="text-blue-600 underline break-all cursor-pointer"
                @click="openUpdate">注釈ページ</button>をご覧ください。</li>
          </ul>
        </div>
      </template>
      <div v-if="isAddTeiki" class="text-center mb-2 font-bold text-blue-600 underline break-all cursor-pointer mt-2"
        @click="top()">
        ←TOPに戻る
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants from '@/constants';

export default {
  data() {
    return {
      mode: 'teiki',
      from: null,
      to: null,
      via1: null,
      via2: null,
      via3: null,
      viaCount: 0,
      teikiKind: 'bussiness',
      teikiValidity: "1",
      errors: [],
      isAddTeiki: false,
      isUsePage: Constants.IS_USER_PAGE && Constants.IS_USER_PAGE === 'true',
    }
  },
  computed: mapGetters({
    isMobile: 'getIsMobile',
    serializeData: 'getSerializeData',
  }),
  async mounted() {
    if (this.$route.name === 'AddTeiki' && this.serializeData.length > 0) {
      this.isAddTeiki = true;
    } else {
      this.$store.commit('reset');
    }
    this.from = new window.expGuiStation(this.$refs.from);
    this.from.setConfigure("apiURL", Constants.API_BASE_URL);
    this.from.setConfigure("type", this.from.TYPE_TRAIN);
    if (this.serializeData.length === 0) {
      this.from.setConfigure("corporationBind", "ＪＲ東日本");
    } else {
      this.from.setConfigure("corporationBind", "連絡運輸");
    }
    this.from.setConfigure("agent", 1);
    this.from.setConfigure("isMobile", this.isMobile);
    this.from.dispStation();
    this.to = new window.expGuiStation(this.$refs.to);
    this.to.setConfigure("apiURL", Constants.API_BASE_URL);
    this.to.setConfigure("type", this.to.TYPE_TRAIN);
    this.to.setConfigure("corporationBind", "連絡運輸");
    this.to.setConfigure("agent", 1);
    this.to.setConfigure("isMobile", this.isMobile);
    this.to.dispStation();
    this.via1 = new window.expGuiStation(this.$refs.via1);
    this.via1.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via1.setConfigure("type", this.via1.TYPE_TRAIN);
    this.via1.setConfigure("corporationBind", "連絡運輸");
    this.via1.setConfigure("agent", 1);
    this.via1.setConfigure("isMobile", this.isMobile);
    this.via1.dispStation();
    this.via2 = new window.expGuiStation(this.$refs.via2);
    this.via2.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via2.setConfigure("type", this.via2.TYPE_TRAIN);
    this.via2.setConfigure("corporationBind", "連絡運輸");
    this.via2.setConfigure("agent", 1);
    this.via2.setConfigure("isMobile", this.isMobile);
    this.via2.dispStation();
    this.via3 = new window.expGuiStation(this.$refs.via3);
    this.via3.setConfigure("apiURL", Constants.API_BASE_URL);
    this.via3.setConfigure("type", this.via3.TYPE_TRAIN);
    this.via3.setConfigure("corporationBind", "連絡運輸");
    this.via3.setConfigure("agent", 1);
    this.via3.setConfigure("isMobile", this.isMobile);
    this.via3.dispStation();
    this.from.bind("blur", () => {
      this.from.closeStationList();
    });
    this.to.bind("blur", () => {
      this.to.closeStationList();
    });
    this.via1.bind("blur", () => {
      this.via1.closeStationList();
    });
    this.via2.bind("blur", () => {
      this.via2.closeStationList();
    });
    this.via3.bind("blur", () => {
      this.via3.closeStationList();
    });
    if (this.$route.query.viaList) {
      let viaList = this.$route.query.viaList.split(':');
      const from = viaList.shift();
      this.from.setStation(from);
      const to = viaList.pop();
      this.to.setStation(to);
      if (viaList.length > 0) {
        this.via1.setStation(viaList[0]);
        this.viaCount = 1;
      }
      if (viaList.length > 1) {
        this.via2.setStation(viaList[1]);
        this.viaCount = 2;
      }
      if (viaList.length > 2) {
        this.via3.setStation(viaList[2]);
        this.viaCount = 3;
      }
      this.from.closeStationList();
      this.to.closeStationList();
      this.via1.closeStationList();
      this.via2.closeStationList();
      this.via3.closeStationList();
    }
    if (this.$route.query.teikiKind) {
      this.teikiKind = this.$route.query.teikiKind;
    }
    if (this.$route.query.teikiValidity) {
      this.teikiValidity = this.$route.query.teikiValidity;
    }
  },
  methods: {
    search: function (type) {
      this.from.closeStationList();
      this.to.closeStationList();
      this.via1.closeStationList();
      this.via2.closeStationList();
      this.via3.closeStationList();
      this.errors.splice(0);
      if (this.from.getStationName().length === 0) {
        if (this.from.getStation().length === 0) {
          this.errors.push('乗車駅を入力してください');
        } else {
          this.errors.push('乗車駅に誤りがあります');
        }
      }
      if (this.viaCount === 1 && this.via1.getStationName().length === 0) {
        if (this.via1.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      } else if (this.viaCount === 2 && this.via2.getStationName().length === 0) {
        if (this.via2.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      } else if (this.viaCount === 3 && this.via3.getStationName().length === 0) {
        if (this.via3.getStation().length === 0) {
          this.errors.push('経由駅を入力してください');
        } else {
          this.errors.push('経由駅に誤りがあります');
        }
      }
      if (this.to.getStationName().length === 0) {
        if (this.to.getStation().length === 0) {
          this.errors.push('降車駅を入力してください');
        } else {
          this.errors.push('降車駅に誤りがあります');
        }
      }
      if (this.from.getStationName().length > 0 && this.from.getStationName() === this.to.getStationName() && this.viaCount === 0) {
        this.errors.push('乗車駅と降車駅が同一です');
      }
      if (this.errors.length === 0) {
        let viaList = [];
        viaList.push(this.from.getStationName());
        if (this.via1.getStationCode()) {
          viaList.push(this.via1.getStationName());
        }
        if (this.via2.getStationCode()) {
          viaList.push(this.via2.getStationName());
        }
        if (this.via3.getStationCode()) {
          viaList.push(this.via3.getStationName());
        }
        viaList.push(this.to.getStationName());
        this.$store.commit('setViaList', viaList);
        this.$store.commit('setType', type);
        this.$store.commit('setMode', this.mode);
        this.$store.commit('setTeikiKind', this.teikiKind);
        if (!this.isAddTeiki) {
          this.$store.commit('setTeikiValidity', this.teikiValidity);
        }
        if (this.$route.name === 'AddTeiki' && this.serializeData.length > 0) {
          this.$router.push({ name: 'AddTeikiList' });
        } else {
          this.$router.push({ name: 'TeikiList' });
        }
      }
    },
    addVia: function () {
      this.errors.splice(0);
      this.viaCount++;
    },
    deleteVia: function (index) {
      this.errors.splice(0);
      const via2 = this.via2.getStationName();
      const via3 = this.via3.getStationName();
      switch (index) {
        case 1:
          if (this.viaCount === 3) {
            this.via1.setStation(via2);
            this.via2.setStation(via3);
            this.via3.setStation('');
            this.via3.closeStationList();
          } else if (this.viaCount === 2) {
            this.via1.setStation(via2);
            this.via2.setStation('');
            this.via2.closeStationList();
          } else {
            this.via1.setStation('');
            this.via1.closeStationList();
          }
          break;
        case 2:
          if (this.viaCount === 3) {
            this.via2.setStation(via3);
            this.via3.setStation('');
            this.via3.closeStationList();
          } else {
            this.via2.setStation('');
            this.via2.closeStationList();
          }
          break;
        case 3:
          this.via3.setStation('');
          this.via3.closeStationList();
          break;
      }
      this.viaCount--;
    },
    openUpdate: function () {
      window.open('./#/update', '_blank');
    },
    back: function () {
      this.$router.push({ name: 'TeikiResult' });
    },
    top: function () {
      this.$store.commit('reset');
      this.isAddTeiki = false;
      this.$router.push({ name: 'TeikiTop' });
    },
  }
}
</script>

<style scoped>
.section {
  width: 60rem;
}

ul {
  list-style-type: none;
}

li {
  padding-left: em;
  text-indent: -1em;
}
</style>
